<div
  #bellElement
  id="NotificationBell"
  class="clsNotificationBell clsCursorPointer clsAutoEvent"
  (click)="showNotifications()"
  (keydown)="showNotifications()"
  [ngClass]="{
    liveAppHasSecurityIssues: liveVersionSecurityBannerData !== null
  }"
>
  <i
    id="NotificationBellIcon"
    class="clsNotificationBellIcon"
    [ngClass]="{
      clsNotificationBellIconFaded: !dialogOpen,
      clsNotificationBellIconOff: !hasUnreadNotifications
    }"
  >
    <span class="notification-bell-title">{{
      'component.leftNavBar.notifications-section' | translate
    }}</span>
  </i>
  <app-notification-dot
    class="clsNotificationDot"
    *ngIf="hasUnreadNotifications"
    [notificationsNumber]="unreadNotificationsNumber"
  ></app-notification-dot>
</div>
